<div class="demo">
  <div class="demo-type">Simple UI</div>
  <form class="demo-editor">
    <div class="form-group">
      <fate-ui uiId="foo"></fate-ui>
      <fate-input uiId="foo" [(ngModel)]="aboutFate" placeholder="Rich Textarea" name="simple"></fate-input>
    </div>
  </form>
</div>
<div class="demo">
  <div class="demo-type">Bootstrap4 UI</div>
  <form class="demo-editor">
    <div class="form-group">
      <fate-bootstrap [(ngModel)]="aboutFate" name="bootstrap" placeholder="Rich Textarea"></fate-bootstrap>
    </div>
  </form>
</div>
<div class="demo material">
  <div class="demo-type">Material UI</div>
  <form class="demo-editor">
    <div class="form-group">
      <mat-form-field>
        <fate-material [(ngModel)]="aboutFate" placeholder="Rich Textarea" name="material"></fate-material>
      </mat-form-field>
    </div>
  </form>
</div>

<!--
  <strong>debug</strong>
  <textarea type="text" [(ngModel)]="aboutFate"  name="htmlSrc"></textarea>
-->
